import { bulkRegistrationProp } from "../../store/ActionType";

interface CsvTableProps {
  csvData: bulkRegistrationProp[];
  fileName: string;
}

const CsvTable: React.FC<CsvTableProps> = ({ csvData, fileName }) => {
  const columns: { key: keyof bulkRegistrationProp; label: string }[] = [
    { key: "Name", label: "Name" },
    { key: "Cid", label: "CID" },
    { key: "Dob", label: "DOB" },
    { key: "Gender", label: "Gender" },
    { key: "Category", label: "Category" },
    { key: "DzongkhagId", label: "Dzongkhag Id" },
    { key: "SchoolId", label: "School Id" },
    { key: "EccdId", label: "Eccd Id" },
    { key: "GradeId", label: "Grade Id" },
    { key: "Email", label: "Email" },
    { key: "MobileNo", label: "Mobile No." },
    { key: "Password", label: "Password" },
  ];

  return (
    <>
      {csvData.length > 0 && (
        <>
          <p className="text-sm text-gray-700">
            📄 Selected file: <strong>{fileName}</strong>
          </p>
          <div className="border border-gray-200 rounded shadow-sm max-h-[58vh] overflow-auto scrollbar-hide">
            <table className="min-w-full text-[12px] text-left text-gray-800">
              <thead className="bg-gray-100 border-b sticky top-0">
                <tr>
                  <th className="px-2 py-3 font-bold">Sl no.</th>
                  {columns.map((col) => (
                    <th key={col.key as string} className="px-2 py-3 font-bold">
                      {col.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {csvData.map((item, index) => (
                  <tr key={index} className="odd:bg-white even:bg-gray-50">
                    <td className="px-2 py-1 border-t">{index + 1}</td>
                    {columns.map((col) => (
                      <td key={col.key as string} className="px-2 py-3 font-bold">
                        {item[col.key] ?? "-"}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
};

export default CsvTable;
